/**
 * Vehicle Studio / Wallpaper — presentation layer helpers.
 *
 * REUSES the existing YULONTAP wallpaper concept (an optional background image
 * behind a card surface, already used by Review Shield / Card Settings) plus the
 * shared cardSurfaceClass (frosted/clear/solid). This is ONLY a presentation
 * layer: the dealer's uploaded photos (vehicle.photos, photos[0] = main) always
 * remain the source imagery. Nothing here replaces, deletes or edits a photo.
 */
import { cardSurfaceClass, CARD_STYLES, DEFAULT_CARD_STYLE } from './cardSurface';

export { CARD_STYLES, DEFAULT_CARD_STYLE, cardSurfaceClass };

// Built-in "studio" backdrops (pure CSS gradients — no external assets/upload
// required). Dealers may also upload/paste a custom wallpaper image instead.
export const WALLPAPER_PRESETS = [
    { key: 'showroom', label: 'Showroom', css: 'linear-gradient(135deg,#0f172a 0%,#1e293b 100%)' },
    { key: 'graphite', label: 'Graphite', css: 'linear-gradient(135deg,#111827 0%,#374151 100%)' },
    { key: 'carbon', label: 'Carbon', css: 'radial-gradient(circle at 30% 20%,#334155 0%,#0f172a 70%)' },
    { key: 'sunset', label: 'Sunset', css: 'linear-gradient(135deg,#7c2d12 0%,#b45309 100%)' },
    { key: 'ocean', label: 'Ocean', css: 'linear-gradient(135deg,#0c4a6e 0%,#0891b2 100%)' },
    { key: 'ivory', label: 'Ivory', css: 'linear-gradient(135deg,#f8fafc 0%,#cbd5e1 100%)' },
];

export function hasWallpaper(v) {
    return !!(v && (v.wallpaper_url || v.wallpaper_preset));
}

/** Returns an inline style object for the wallpaper background, or null. */
export function wallpaperBgStyle(v) {
    if (!v) return null;
    if (v.wallpaper_url) {
        return { backgroundImage: `url(${v.wallpaper_url})`, backgroundSize: 'cover', backgroundPosition: 'center' };
    }
    const p = WALLPAPER_PRESETS.find((x) => x.key === v.wallpaper_preset);
    return p ? { backgroundImage: p.css } : null;
}
